import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';

export interface StaffUser {
  id: string;
  name: string;
  email: string;
}

/**
 * Fetches active staff users for assignee selection (reminders, tasks, etc.).
 * Returns id, name, and email for each active user in the tenant.
 */
export function useStaffUsers() {
  return useQuery({
    queryKey: ['staff-users'],
    queryFn: async () => {
      const response = await apiClient.get<{ success: boolean; data: Record<string, unknown>[] }>(
        '/users',
        { params: { status: 'active', pageSize: 200 } },
      );

      const users = response.data.data ?? [];

      return users.map(
        (u): StaffUser => ({
          id: u.id as string,
          name: (u.name || '') as string,
          email: (u.email || '') as string,
        }),
      );
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
  });
}
